import type { ClientAttachmentId } from "owa-client-ids";
import type AudioPreviewState from "./AudioPreviewState";
import type IframePreviewState from "./IFramePreviewState";
import type ImagePreviewState from "./ImagePreviewState";
import type NativePdfPreviewState from "./NativePdfPreviewState";
import type TextPreviewState from "./TextPreviewState";
import type VideoPreviewState from "./VideoPreviewState";
import type WacPreviewState from "./WacPreviewState";
import type MsPdfPreviewState from "./MsPdfPreviewState";

export enum PreviewPaneMode {
    Blank,
    Loading,
    Error,
    Custom,
    Image,
    Wac,
    Audio,
    Video,
    Text,
    NativePdf,
    IFrame,
    MsPdf
}

type PreviewPaneViewState = AudioPreviewState | IframePreviewState | ImagePreviewState | NativePdfPreviewState | PreviewPaneBlankViewState | PreviewPaneCustomViewState | PreviewPaneErrorViewState | PreviewPaneLoadingViewState | TextPreviewState | VideoPreviewState | WacPreviewState | MsPdfPreviewState;

export interface PreviewPaneViewStateBase {
    downloadUrl?: string;
    downloadShouldOpenNewTab?: boolean;
    fileName?: string;
    id?: ClientAttachmentId;
    isCloudy?: boolean;
}

export default PreviewPaneViewState;

export interface PreviewPaneBlankViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Blank;
}

export interface PreviewPaneLoadingViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Loading;
    message: string;
}

export interface PreviewPaneErrorViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Error;
    errorMessage: string;
}

export interface PreviewPaneCustomViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Custom;
}
